export const formatSymbolPath = (path: string, increment: number) =>
  Array.from({ length: increment })
    .map(() => '    ')
    .join('') + path
